const databasePageState = (state) => state.databasePage

export const databasePageSelectors = {
    selectedTable: (state) => databasePageState(state).selectedTable,
    formData: (state) => databasePageState(state).formData,
    editingRowId: (state) => databasePageState(state).editingRowId,
    editRowData: (state) => databasePageState(state).editRowData,
    showDeleteModal: (state) => databasePageState(state).showDeleteModal,
    deleteTargetRow: (state) => databasePageState(state).deleteTargetRow,
    isEditing: (state) => databasePageState(state).editingRowId !== null,
}
